import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "scbb_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY) && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => {
    if (!x || typeof x.msg !== "string") return "Please check the form";
    const field = String(x.loc?.[x.loc.length - 1] ?? "").replace(/_/g, " ");
    const msg = x.msg.replace(/^Value error, /, "").split(":")[0];
    return field && field !== "body" ? `${field[0].toUpperCase()}${field.slice(1)}: ${msg}` : msg;
  }).join(". ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const photoUrl = (path) => `${API}/photos/${path}?auth=${localStorage.getItem(TOKEN_KEY)}`;

export function downloadDoc(docId, version, filename) {
  return downloadFile(`/documents/${docId}/download`, filename, { version });
}

export async function downloadFile(path, filename, params) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
